<template lang='pug' src='./custom-home-banner.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: {
    content: {
      type: [Object, Array]
    }
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// custom-home-banner.vue?72686870